
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/roadside/mi",
      function () {
        return require("private-next-pages/roadside/mi.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/roadside/mi"])
      });
    }
  